class ProblemsFilter {
  constructor({
    waterClarity, cloudy, hazy, foaming, spaAlgae, slimeMold,
    algaeProblems, blackAlgae, greenAlgae, mustardAlgae, swampy,
    surfaceProblems, copperStaining, ironStaining, unknownStaining,
    scaleBuildup, waterBuildup, organicStaining,
    chlorineDemand, cDDemand, waterlineBuildup,
  }) {
    this.waterClarity = waterClarity;
    this.cloudy = cloudy;
    this.hazy = hazy;
    this.algaeProblems = algaeProblems;
    this.blackAlgae = blackAlgae;
    this.greenAlgae = greenAlgae;
    this.mustardAlgae = mustardAlgae;
    this.foaming = foaming,
    this.surfaceProblems = surfaceProblems;
    this.copperStaining = copperStaining;
    this.ironStaining = ironStaining;
    this.unknownStaining = unknownStaining;
    this.scaleBuildup = scaleBuildup;
    this.waterBuildup = waterBuildup;
    this.organicStaining = organicStaining;
    this.spaAlgae = spaAlgae;
    this.chlorineDemand = chlorineDemand;
    this.cDDemand = cDDemand;
    this.slimeMold = slimeMold;
    this.swampy = swampy;
    this.waterlineBuildup = waterlineBuildup;
  }

  toApiFormat() {
    return {
      Cloudy: this.waterClarity || this.cloudy,
      Hazy: this.hazy,
      AlgaeProblems: this.algaeProblems,
      BlackAlgae: this.blackAlgae,
      GreenAlgae: this.greenAlgae,
      Foaming: this.foaming,
      MustardAlgae: this.mustardAlgae,
      ChlorineDemand: this.chlorineDemand,
      SurfaceProblems: this.surfaceProblems,
      CopperStaining: this.copperStaining,
      IronStaining: this.ironStaining,
      UnknownStaining: this.unknownStaining,
      ScaleBuildup: this.scaleBuildup,
      WaterBuildup: this.waterBuildup,
      OrganicStaining: this.organicStaining,
      SpaAlgae: this.spaAlgae,
      SlimeMold: this.slimeMold,
      Swampy: this.swampy,
      CDDemand: this.chlorineDemand || this.cDDemand,
      WaterlineBuildup: this.waterlineBuildup,
    };
  }
}

export default ProblemsFilter;
